import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salesDb } from "@/integrations/supabase/sales-client";
import { useAuth } from "@/context/auth";
import { toast } from "sonner";
import type { StudentKind } from "./useEventBalances";

export const useUnassignStudent = () => {
  const { user } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      assignmentId,
      studentCode,
      studentKind,
      eventId,
    }: {
      assignmentId: string;
      studentCode: string;
      studentKind: StudentKind;
      eventId: string;
    }) => {
      if (!user?.email || !user?.id) throw new Error("Not authenticated");
      const nowIso = new Date().toISOString();

      const { data: refund, error: rErr } = await salesDb()
        .from("student_cashbacks")
        .insert({
          fishsix_student_code: studentKind === "fs" ? studentCode : null,
          esc_student_code: studentKind === "esc" ? studentCode : null,
          knoware_student_code: studentKind === "kn" ? studentCode : null,
          hours: 1,
          action: "add",
          cashback_type: "event",
          status: "approved",
          created_by: user.email,
          approved_by: user.email,
          approved_at: nowIso,
        })
        .select("id")
        .single();
      if (rErr) throw rErr;

      const { error: uErr } = await salesDb()
        .from("event_assignments")
        .update({
          status: "unassigned",
          unassigned_at: nowIso,
          unassigned_by: user.id,
          refund_cashback_id: refund.id,
        })
        .eq("id", assignmentId);
      if (uErr) throw uErr;
    },
    onSuccess: (_d, vars) => {
      toast.success("ยกเลิกการมอบหมายและคืนครั้งแล้ว");
      qc.invalidateQueries({ queryKey: ["event-assignments", vars.eventId] });
      qc.invalidateQueries({ queryKey: ["event-balances"] });
      qc.invalidateQueries({ queryKey: ["student-event-history"] });
    },
    onError: (e: any) => {
      toast.error(e?.message ?? "ยกเลิกไม่สำเร็จ");
    },
  });
};
